import { Pipe, PipeTransform } from '@angular/core';
import { MinimalProfileSetDto } from '../../core/services/GPRMV1Service.Generated';

@Pipe({
    name: 'scalableProfileSet',
    standalone: false
})
export class ScalableProfilesetPipe implements PipeTransform {

  transform(profileSets: MinimalProfileSetDto[] | any[]): MinimalProfileSetDto[] | any {
    if (profileSets && profileSets.length > 0) {
      const scalableProfileSets = profileSets.filter((profileSet: MinimalProfileSetDto | any) => profileSet.isScalable);
      return scalableProfileSets || [];
    }
    return [];
  }

}
